import { type User } from '../../models/User'
import { type InviteResponse } from '../../store/auth/auth'

interface TeamRowBase {
  id: string
  name: string
  email: string
  roleIds: string[]
  createdAt?: string
  status: string
}

export interface MemberRow extends TeamRowBase {
  kind: 'member'
  member: User
}

export interface InviteRow extends TeamRowBase {
  kind: 'invite'
  invite: InviteResponse
}

export type TeamRow = MemberRow | InviteRow

const DEACTIVATED_SUFFIX = /\s\(deactivated\)$/

export const inviteName = ({ name, firstName, lastName }: InviteResponse['user']) => {
  if (name) {
    return name
  }
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}

export const toMemberRow = (member: User): MemberRow => ({
  kind: 'member',
  id: member.id,
  name: member.name.replace(DEACTIVATED_SUFFIX, ''),
  email: member.email,
  roleIds: member.roles.map((role) => role.id),
  createdAt: member.createdAt,
  status: member.status ?? '',
  member,
})

export const toInviteRow = (invite: InviteResponse): InviteRow => ({
  kind: 'invite',
  id: invite.id,
  name: inviteName(invite.user),
  email: invite.user.email,
  roleIds: invite.user.roleIds,
  createdAt: invite.createdAt,
  status: invite.state,
  invite,
})
